module.exports = __webpack_public_path__ + "img/step-1-mobile.7fd57c53.gif";